import React, { forwardRef } from 'react';
import Chip from '@mui/material/Chip';
import PropTypes from 'prop-types';
import * as R from 'ramda';

const chipStyle = {
  '& > .MuiChip-label': { px: 0 },
  borderRadius: 0.5,
  fontSize: 12,
  fontWeight: 'normal',
  height: 20,
  maxWidth: 'none',
  px: 1,
  py: 0.5,
  width: 'min-content',
};

/** Contains strings for batch statuses as a single source of truth. */
export const STATUS_CHIP = {
  CANCELED: 'Canceled',
  CANNOT_BOOK: 'Cannot Book',
  CLOSED: 'Closed',
  EXPIRED: 'Expired',
  NEEDS_ATTENTION: 'Needs Attention',
  OPEN: 'Open',
  SCHEDULED: 'Scheduled',
  UNCONFIRMED: 'Unconfirmed',
};

const StatusChip = forwardRef(function StatusChip(props, ref) {
  const customStyle = R.cond([
    [
      R.equals(STATUS_CHIP.CANNOT_BOOK),
      R.always({ backgroundColor: 'error.dark', color: 'surface.white' }),
    ],
    [R.equals(STATUS_CHIP.UNCONFIRMED), R.always({ backgroundColor: 'warning.main' })],
    [R.equals(STATUS_CHIP.SCHEDULED), R.always({ backgroundColor: 'success.light' })],
    [R.equals(STATUS_CHIP.OPEN), R.always({ backgroundColor: 'success.light' })],
    [R.equals(STATUS_CHIP.CLOSED), R.always({ backgroundColor: 'primary.light' })],
    [R.equals(STATUS_CHIP.EXPIRED), R.always({ backgroundColor: 'success.lighter' })],
    [R.equals(STATUS_CHIP.CANCELED), R.always({ backgroundColor: 'graphic.light' })],
    [R.equals(STATUS_CHIP.NEEDS_ATTENTION), R.always({ backgroundColor: 'warning.main' })],
  ]);

  return (
    <Chip
      {...props}
      label={props.status}
      ref={ref}
      sx={{ ...chipStyle, ...customStyle(props.status), cursor: 'pointer' }}
    />
  );
});

StatusChip.propTypes = {
  status: PropTypes.string.isRequired,
};

export default StatusChip;
